/**
 * ADR-0185 Phase B — the dock (sticky at the bottom of the view): the queued
 * count, the honest progress line while a replan runs (the worker's own
 * stage stamp + elapsed + the real 30–45 s framing), Reset to Plex schedule,
 * Set to optimized, Replan, and — once a replan stands — Make this the plan.
 * The resets confirm before discarding moves (the view owns that dialog).
 */
import { stageLine } from "./refineMath.js";

export function RefineDock(props: {
  pendingCount: number;
  basis: "optimized" | "plex" | "refined";
  hasRefined: boolean;
  busy: boolean;
  inFlight: { stage: string | null; elapsedS: number } | null;
  onReset: (to: "plex" | "optimized") => void;
  onReplan: () => void;
  onPromote: () => void;
}) {
  const n = props.pendingCount;
  const progress = props.inFlight ? stageLine(props.inFlight.stage, props.inFlight.elapsedS) : null;
  return (
    <div className="boardDock" role="region" aria-label="Refine">
      <span className="boardDockChip">
        {progress ? "Replanning" : n === 0 ? "No moves pending" : `${n} move${n === 1 ? "" : "s"} pending`}
      </span>
      {progress ? (
        <>
          <div className="boardDockProgress" aria-hidden="true">
            <i style={{ width: `${Math.round(progress.fraction * 100)}%` }} />
          </div>
          <span className="boardDockStage" role="status">{progress.text}</span>
        </>
      ) : (
        <span className="muted boardDockNote">
          {props.basis === "refined"
            ? "Refined stands — make it the standing plan, or keep moving jobs and replan"
            : props.basis === "plex"
              ? "Refined = the Plex schedule — click a job to move it"
              : "Refined = Optimized — click a job on its row to move it"}
        </span>
      )}
      <span className="boardDockGrow" />
      <button type="button" className="btn btnSm boardDockGhost" disabled={props.busy || !!progress} onClick={() => props.onReset("plex")}>
        Reset to Plex schedule
      </button>
      <button type="button" className="btn btnSm boardDockGhost" disabled={props.busy || !!progress} onClick={() => props.onReset("optimized")}>
        Set to optimized
      </button>
      {props.hasRefined ? (
        <button type="button" className="btn btnSm boardDockGhost" disabled={props.busy || !!progress} onClick={props.onPromote}>
          Make Refined the standing plan
        </button>
      ) : null}
      <button type="button" className="btn btnPrimary btnSm boardDockReplan" disabled={props.busy || !!progress || n === 0} onClick={props.onReplan}>
        Replan
      </button>
    </div>
  );
}
